export default "__VITE_ASSET__a1311cbe__"